import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useParams } from 'react-router-dom';
import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import LocalityDetail from '@app/pages/customer/LocalityDetail/LocalityDetail.tsx';
import LocalityDetailLegacy from '@app/pages/customer/LocalityDetail/LocalityDetailLegacy.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import LegacyVersionSwitch from '@components/framework/LegacyVersionSwitch.tsx';
import { BetaSurface } from '@hooks/useBetaVersion/betaSurfaces';

const LocationDetailPage = () => {
  const { tr } = useTranslationLgs();
  const { id } = useParams();

  return (
    <>
      {id && (
        <ResponsiveLayout title={tr('LocalityDetail.locationDetail', 'Location detail')}>
          <LegacyVersionSwitch surface={BetaSurface.COMPANY_LOCATION_DETAIL}>
            {showLegacy => (showLegacy ? <LocalityDetailLegacy localityId={id as string} /> : <LocalityDetail localityId={id as string} />)}
          </LegacyVersionSwitch>
        </ResponsiveLayout>
      )}
    </>
  );
};

export default withAuthenticationRequired(LocationDetailPage);
